import { Box, StatusLabel } from '@factorialco/deprecated-design-system'
import { BankingEntitiesPaymentStatusEnum } from 'generated/resources/graphql'

import { statusLabelType, statusText } from 'modules/banking/lib/mappers'

type Props = {
  status: BankingEntitiesPaymentStatusEnum
}

export const Status = ({ status }: Props) => {
  return (
    <Box flexDirection="row" alignItems="center" gap="s8">
      <StatusLabel type={statusLabelType(status)}>{statusText(status)}</StatusLabel>
    </Box>
  )
}
